export default __webpack_public_path__ + "static/media/about_us.24d3698c.jpg";